<template>
    <modal-dialog
        id="video-player-dialog"
        :show.sync="shown"
        :dismissable="true"
        class="modal-lg text-center"
    >
        <video-player
            :settings="settings"
            @play="track_event('Video', 'Play', name)"
            @ended="track_event('Video', 'End', name)"
        />
    </modal-dialog>
</template>

<script>
import tracks from "@/custom/mixins/Tracks"

import ModalDialog from "@/nibnut/components/ModalDialog/ModalDialog"
import VideoPlayer from "@/custom/components/VideoPlayer"

export default {
    name: "VideoPlayerDialog",
    mixins: [tracks],
    components: {
        ModalDialog,
        VideoPlayer
    },
    computed: {
        shown: {
            get () {
                return !!this.show && !!this.settings && !!this.settings.src
            },
            set (show) {
                this.$emit("update:show", show)
            }
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            required: true
        },
        settings: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss">
#video-player-dialog.modal.modal-lg {
    .modal-container, .modal-body {
        padding: 0;
    }
}
</style>
